import React, {useMemo} from 'react'
import {TextProps} from "antd/es/typography/Text";
import {useTranslation} from "react-i18next";
import {Link, LinkProps} from "react-router-dom";

export type LabelProps = TextProps & {
    link: LinkProps;
    trl: string
    segments?: {key: string, value: string}[]
};

export const LabelLink: React.FC<LabelProps> = (props) => {
    const {link, trl, segments} = props;
    const {t} = useTranslation();
    const text = useMemo(() => {
        let out = t(trl);
        if (segments) {
            segments.forEach(segment => {
                out = out.replaceAll(segment.key, segment.value);
            });
        }
        return ` ${out} `;
    }, [t]);

    return (
        <Link {...link}>{text}</Link>
    )
}